import React, { Component } from 'react';
import { Link } from "react-router-dom";
import { default as minifyCssString } from 'minify-css-string'
import Nav from "./nav";
 import Fot from "./foot";
import { Helmet } from "react-helmet";
import Modal from "react-animated-modal";
import $ from "jquery";
import ReCAPTCHA from "react-google-recaptcha";

import axios from 'axios';
const recaptchaRef = React.createRef();

class  mid extends Component {
   constructor(props) {
        super(props);
        this.state = {
        showModal: false,
        warn: ''

    };
 
    }
        


onSubmit = (e) =>{
let tu = 'false'
e.preventDefault();
 
       $.ajax({
            url: 'https://cikoleforestrun.co.id/server/mail.php',
             //url: 'https://localhost/phpmailer/mail.php',
            data: $('#postme').serialize(),
            type: 'POST',
            success: function(response) { 
 if(response == 'capta'){
                
                  $('.modal').show();
                     $('.modal-title').html('Terjadi Kesalahan')

                     $('.titleerror').html('Captcha verification gagal, harap coba kembali.')
       return
                 }
                 else if(response === 'no'){ 
                     $('.modal').show();
                                                             $('.modal-title').html('Terjadi Kesalahan')

                     $('.titleerror').html('Maaf, periksa kembali input anda.')
       return
                 }else if(response === 'empty mail'){
                    $('.modal').show();
                                        $('.modal-title').html('Terjadi Kesalahan')
                     $('#c_email').css({'border-color':'#e62f3e'})
                     $('.titleerror').html('Maaf, periksa kembali input anda.')
       return
                 }else if(response === 'ok'){

                    $('.modal').show();
                    $('.modal-title').html('Pesan Terkirim')
                     $('.titleerror').html('Terima kasih, pesan anda sudah berhasil terkirim')
                             $('.form-control').val('')
   $('.form-control').css({'border-color':'#ced4da'})
       return
                 }else if(response === 'empty name'){
                  $('.modal').show();
                                                          $('.modal-title').html('Terjadi Kesalahan')
                     $('#c_fname').css({'border-color':'#e62f3e'})

                     $('.titleerror').html('Maaf, periksa kembali input anda.')
       return
                 }else if(response === 'empty lastname'){
                 $('.modal').show();
                                                         $('.modal-title').html('Terjadi Kesalahan')
                     $('#c_lname').css({'border-color':'#e62f3e'})

                     $('.titleerror').html('Maaf, periksa kembali input anda.')
       return
                 }else if(response === 'empty mesage'){
                  $('.modal').show();
                                                          $('.modal-title').html('Terjadi Kesalahan')

                     $('.titleerror').html('Maaf, periksa kembali input anda.')
       return
                 }else if(response == 'Failed'){
                
                  $('.modal').show();
                                                          $('.modal-title').html('Terjadi Kesalahan')

                     $('.titleerror').html('Maaf, periksa kembali input anda.')
       return
                 }else if(response == 'no method'){
                
                  $('.modal').show();
                                                          $('.modal-title').html('Terjadi Kesalahan')

                     $('.titleerror').html('Maaf, periksa kembali input anda.')
       return
                 }
            },
            error: function(error) {
                   $('.modal').show();
                                                           $('.modal-title').html('Terjadi Kesalahan')

                     $('.titleerror').html('Maaf, periksa kembali input anda.')
       return
            }
        });
 return false;
 



}
    render() {

 
$('body').on('click', '#moreclodse', function(e) {
             $('.modal').hide()
                                                            $('.modal-title').html('')
                     $('.titleerror').html('')

         });


     let { error } = this;




    		const cssString = `
        .capta{
          margin-bottom: 10px;
         }
        .modal{
              background: #333c !important;
        }
        .error{
               text-align: center;
    padding: 2rem !important;
        }
        .site-section{
          padding-top: 0;
          padding-bottom: 0;
        }
        .react-modal-body-close{
          display: none;
        }
        .lla {

              position: relative;
    font-weight: bold;
    font-family: mor;
    letter-spacing: 1px;
    text-transform: uppercase;
        }
        .h3{
              font-family: arial;
    text-transform: uppercase;
    font-weight: bold;
    letter-spacing: 1px;
        }
#kkbox{
       top: -150px;
    position: relative;
    padding: 50px;
    z-index: 9;
    background: #fff;
}
#googleMap {
    width: 100%;
    height: 550px;
}
#hog:hover{
  background: #c2ff19 !important;
  color: #212D61 !important;
}
  body{
          font-family: arial;
    color: #25262a;
        }
        .text-primary{
            font-family: Mor;
    color: #25262a !important;
        }
        #hog{
          background: #272F5F;
              border-radius: 5px;
    padding: 15px !important;
        }
         #hog{
          background: #272F5F;
        }
        #los{
              max-width: 100%;
    padding: 0;
        }
.App{
	text-align: center;
}
@media (max-width: 992px) {
 .col-md-7{
  margin-bottom: 50px;
 }
 #kkbox {
      padding-top: 60px !important;

    padding: 15px;
    
}




 #recaptcha_challenge_image{
    margin: 0 !important;
    width: 100% !important;
    height: auto !important;
    }
    #recaptcha_response_field
    {
    margin: 0 !important;
    width: 100% !important;
    height: auto !important;
    }
    .recaptchatable #recaptcha_image {
    margin: 0 !important;
    width: 100% !important;
    height: auto !important;
    }
    .recaptchatable .recaptcha_r1_c1, 
    .recaptchatable .recaptcha_r3_c1, 
    .recaptchatable .recaptcha_r3_c2, 
    .recaptchatable .recaptcha_r7_c1, 
    .recaptchatable .recaptcha_r8_c1, 
    .recaptchatable .recaptcha_r3_c3, 
    .recaptchatable .recaptcha_r2_c1, 
    .recaptchatable .recaptcha_r4_c1, 
    .recaptchatable .recaptcha_r4_c2, 
    .recaptchatable .recaptcha_r4_c4, 
    .recaptchatable .recaptcha_image_cell {

    margin: 0 !important;
    width: 100% !important;
    background: none !important;
    height: auto !important;
    }







}`;













       

        return (

            <div>
  <Helmet>
                <meta charSet="utf-8" />
                <title>Cikole Forest Run | contact page </title>
                
             </Helmet>
                          <style dangerouslySetInnerHTML={{__html: minifyCssString(cssString) }} /> 
                           <Modal
                    visible={this.state.showModal}
                    closemodal={() => this.setState({ showModal: false })}
                    type="fadeInUp"
                >
                    <div className="modal-header"><div className="modal-title h4" id="contained-modal-title-vcenter">Information</div></div>

                    <div className="modal-body"><h4>Not yet implemented </h4><p>{this.state.warn}
</p></div>
                </Modal>
<Nav />


                 <div className="site-section">
                 <div className="llps">
                 <div id="googleMap"><iframe frameborder="0" height="100%" scrolling="no" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3961.1811062020242!2d107.55970301477252!3d-6.868889995036256!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e68e43d4dd647f9%3A0xb9039aa477dfc490!2sBlok-C%2C%20Jl.%20Flamboyan%20III%20No.1%2C%20Cibabat%2C%20Kec.%20Cimahi%20Utara%2C%20Kota%20Cimahi%2C%20Jawa%20Barat%2040513!5e0!3m2!1sen!2sid!4v1570505388626!5m2!1sen!2sid" width="100%"></iframe></div>
      </div>
      <div id="kkbox" className="container">
        <div className="row">
          <div className="col-md-12">
          </div>
          <div className="col-md-7">
            <form id="postme" onSubmit={this.onSubmit}>
    
              <div className="p-3 p-lg-5 border">
                <div className="form-group row">
                  <div className="col-md-6">
                    <label for="c_fname" className="text-black">First Name <span className="text-danger">*</span></label>
                    <input type="text" className="form-control" id="c_fname" name="c_fname"  />
                  </div>
                  <div className="col-md-6">
                    <label for="c_lname" className="text-black">Last Name <span className="text-danger">*</span></label>
                    <input type="text" className="form-control" id="c_lname" name="c_lname" />
                  </div>
                </div>
                <div className="form-group row">
                  <div className="col-md-12">
                    <label for="c_email" className="text-black">Email <span className="text-danger">*</span></label>
                    <input type="email" className="form-control" id="c_email" name="c_email" placeholder="" />
                  </div>
                </div>
                <div className="form-group row">
                  <div className="col-md-12">
                    <label for="c_subject" className="text-black">Subject </label>
                    <input type="text" className="form-control" id="c_subject" name="c_subject" />
                  </div>
                </div>

                <div className="form-group row">
                  <div className="col-md-12">
                    <label for="c_message" className="text-black">Message </label>
                    <textarea name="c_message" id="c_message" cols="30" rows="7" className="form-control"></textarea>
                  </div>
                </div>
                <div className="form-group row">
                  <div className="col-lg-12">
                    <ReCAPTCHA className="capta"
        ref={recaptchaRef}
        sitekey=" 6LcQ2rwUAAAAALpyRhaxSpWSFke3dNljDsqT_rEi"
      
      />

                    <input id="hog" type="submit"   className="btn btn-primary btn-lg btn-block" value="Send Message" />
                  </div>
                </div>
              </div>

            </form> 


<div className="modal" tabindex="-1" role="dialog">
  <div className="modal-dialog" role="document">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title"></h5>
       
      </div>
      <div className="modal-body">
        <p className="titleerror"></p>
      </div>
      <div className="modal-footer">
         <button id="moreclodse" type="button"   className="btn btn-secondary" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>






           
          </div>
          <div className="col-md-5 ml-auto">
            <div className="p-4 border mb-3">
              <span className="d-block text-primary h6 text-uppercase lla">Address</span>
              <p className="mb-0">Blok-C
Jl. Flamboyan III No.1, Cibabat, Kec. Cimahi Utara, Kota Cimahi, Jawa Barat 40513</p>
            </div>
            <div className="p-4 border mb-3">
              <span className="d-block text-primary h6 text-uppercase lla">Phone</span>
              <p className="mb-0">+62 813-9420-7933</p>
            </div>
            <div className="p-4 border mb-3">
              <span className="d-block text-primary h6 text-uppercase lla">Email

</span>
              <p className="mb-0">info@cikoleforestrun.co.id</p>
            </div>

          </div>
        </div>
      </div>
    </div>
  <Fot />
 
      </div>

        );
    }
}
export default mid;